// import { ReservationAddress } from '../../data/models/reservation.model';
import { PassengerAddress } from './../../data/models/passenger.model';

export const useAddress = (
  address?: PassengerAddress /* | ReservationAddress*/,
): string => {
  if (address) {
    // TODO: this will have to be fixed up once addresses are made consisten in the APIs
    if (address.addressLine2) {
      return `${address.addressLine1} ${address.addressLine2} ${address.city}, ${address.stateCode} ${address.zipCode}`;
    } else if (address.addressLine1) {
      return `${address.addressLine1} ${address.city}, ${address.stateCode} ${address.zipCode}`;
      // } else {
      //   const addr = address as ReservationAddress;
      //   const state = addr.stateCode ? addr.stateCode : (addr as any).state.value;
      //   return `${addr?.addressLine1} ${addr.city}, ${state} ${addr.zipCode}`;
    }
  }
  return '';
};
